module.exports = __webpack_public_path__ + "static/media/Yelpcamp_full.7cfbda7c.JPG";